import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import AuthLayout from '../layouts/AuthLayout';
// guards
import AuthGuard from '../guards/AuthGuard';
import GuestGuard from '../guards/GuestGuard';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    // Kirish
    {
      path: 'auth',
      element: (
        <GuestGuard>
          <AuthLayout />
        </GuestGuard>
      ),
      children: [
        { element: <Navigate to="/auth/login" replace />, index: true },
        { path: 'login', element: <Login /> },
      ],
    },

    // Boshqaruv paneli (himoyalangan)
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/dashboard/app" replace />, index: true },
        { path: 'app', element: <GeneralHome /> },
        { path: 'applicants', element: <Applicants /> },
        { path: 'subjects', element: <Subjects /> },
        { path: 'grades', element: <Grades /> },
      ],
    },

    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    { path: '/', element: <Navigate to="/dashboard" replace /> },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// Kirish
const Login = Loadable(lazy(() => import('../pages/auth/Login')));

// Boshqaruv paneli
const GeneralHome = Loadable(lazy(() => import('../pages/dashboard/GeneralHome')));
const Applicants = Loadable(lazy(() => import('../pages/dashboard/Applicants')));
const Subjects = Loadable(lazy(() => import('../pages/dashboard/Subjects')));
const Grades = Loadable(lazy(() => import('../pages/dashboard/Grades')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
